
import { Component, Vue } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";

@Component({
  name: "Login",
  components: {},
})
export default class extends Vue {
  $refs!: {
    form: HTMLFormElement;
  };
  private valid = false;
  private codeSent = false;
  private loading = false;
  private show1 = false;
  private mobile = "";
  private code = "";

  private userNameRules = [
    (v: string) => !!v || "نام کاربری الزامی میباشد",
    (v: string) => /^(09|9)+([0-9]){9}$/.test(v) || "شماره موبایل اشتباه است",
  ];

  private async getCode() {
    this.loading = true;
    try {
      await UserModule.GetCode(this.mobile);
      this.loading = false;
      this.codeSent = true;
      // this.$router.push("/change-password");
    } catch (error) {
      this.loading = false;
    }
  }
  private async verifyCode() {
    this.loading = true;
    try {
      await UserModule.VerifyCode({ code: this.code, mobile: this.mobile });
      this.loading = false;
      if (UserModule.verfied) this.$router.push("/change-password");
    } catch (error) {
      this.loading = false;
    }
  }
  private validationForm() {
    this.$refs.form.validate();
  }
}
